export default __webpack_public_path__ + "static/jason-lorenti-9295e96dcc2125394ac20f922c978283.jpg";